import React from 'react';
import moment from 'moment';
import { CURRENCY_SYMBOLS } from '../../../../utils/constants/currency-symbols';
import { onFormatPaymentStatus } from '../../../../utils/constants/payment-statuses';
import { useGetReservationPaymentsInfoQuery } from '../../../../store/reservations/reservationsApi';
import Button from '../../../../shared/button';
import Modal from '../../../../shared/modal';


interface IReservationDetailsModal {
    openModal: boolean;
    data: any;
    handleCloseModal: () => void;
}

const ReservationDetailsModal = ({
    openModal,
    data,
    handleCloseModal,
}: IReservationDetailsModal) => {
    const { data: paymentDataInfo, isLoading } = useGetReservationPaymentsInfoQuery(data?._id || '');

    const onCloseModal = () => {
        handleCloseModal();
    }

    const onClickDownloadInvoice = (link: string) => {
        window.open(link, '_blank')
    }

    const onClickCopy = async () => {
        if ('clipboard' in navigator) {
            await navigator.clipboard.writeText(data?._id);
        }
    }

    const value = onFormatPaymentStatus(data?.paymentDetails?.paymentStatus)?.name
    const text = onFormatPaymentStatus(data?.paymentDetails?.paymentStatus)?.text || 'text-black'
    const item = <div className={`flex flex-row justify-center text-center ${text} text-sm font-medium`}>{value || ''}</div>
    const nights = moment(data?.reservationDetails?.checkoutDate).diff(moment(data?.reservationDetails?.checkinDate), "days");
    const totalPriceEverything = (paymentDataInfo?.data && paymentDataInfo?.data?.length > 0) && paymentDataInfo?.data?.reduce((accumulator: any, currentValue: any) => accumulator + (currentValue?.paymentDetails?.total), 0)
    const findRoomReservation = paymentDataInfo?.data?.find((item: any) => item?.productType === 'room_reservation')
    return (
        <Modal
            open={openModal}
            showInRight
            onClose={() => onCloseModal()}
            title='Reservation Info'
            contentContainerStyle='!min-w-[70vw]'>
            <div className={'p-2 min-w-[65vw] min-h-[300px]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Reservation Details Info</p>
                </div>
                <div className='bg-[#f9f9f9] rounded-[6px] p-3'>
                    <div className='flex flex-row'>
                        <img src={'/assets/shared/user-circle.svg'} className='object-contain w-[90px] mr-5' />
                        <div>
                            <p className='page-title !mb-1 !text-[18px]'>Guest: {data?.guestDetails?.name}</p>
                            <div onClick={onClickCopy} className='flex flex-row items-center'>
                                <p className='text-[#5D6679]'>Reservation ID: {data?._id}</p>
                                <img src={'/assets/shared/copy.svg'} className='ml-2 object-contain w-[17px] cursor-pointer' />
                            </div>
                            <p className='text-[#5D6679]'>{data?.guestDetails?.email}{data?.guestDetails?.phone ? `, ${data?.guestDetails?.phone}` : ''}</p>
                        </div>
                    </div>
                    <div className='mt-6 !rounded-xl border-2 border-call-default'>
                        <div className={'border-b border-b-call-default py-3 px-2 bg-[#f8f9fd]'}>
                            <p className='text-[#5D6679] text-[14px]'>Booking Details</p>
                        </div>
                        <div className='py-3 px-2 bg-[#ffffff]'>
                            <p className='text-[#5D6679] mb-2'>{data?.reservationDetails?.roomType}</p>
                            <p className='text-[#5D6679] mb-2'>Room {data?.reservationDetails?.roomNumber}</p>
                            <p className='text-[#5D6679] mb-2'>{data?.reservationDetails?.numberOfGuests} Guests</p>
                            {data?.reservationDetails?.checkinDate && <p className='mb-2 mr-4 text-[#5D6679]'>Check-In on {moment(data?.reservationDetails?.checkinDate).format('DD/MM/YYYY mm:hh A')}</p>}
                            {data?.reservationDetails?.checkoutDate && <p className='mb-2 text-[#5D6679]'>Check-Out on {moment(data?.reservationDetails?.checkoutDate).format('DD/MM/YYYY mm:hh A')}</p>}
                            <p className='text-[#5D6679]'>Staying in: {data?.hotelDetails?.hotelName} ({data?.hotelDetails?.hotelAddress})</p>
                        </div>
                    </div>
                    <div className='mt-6 !rounded-xl border-2 border-call-default'>
                        <div className={'border-b border-b-call-default py-3 px-2 bg-[#f8f9fd]'}>
                            <p className='text-[#5D6679] text-[14px]'>Created By</p>
                        </div>
                        <div className='py-3 px-2 bg-[#ffffff]'>
                            <p className='text-[#5D6679] mb-2'>{data?.createdBy}</p>
                            <p className='text-[#5D6679]'>at {moment(data?.createdAt).format('DD/MM/YYYY mm:hh A')}</p>
                        </div>
                    </div>
                    <div className='mt-6 !rounded-xl border-2 border-call-default'>
                        <div className={'border-b border-b-call-default py-3 px-2 bg-[#f8f9fd]'}>
                            <p className='text-[#5D6679] text-[14px]'>Services</p>
                        </div>
                        <div className='py-3 px-4 bg-[#ffffff]'>
                            <div className='grid grid-cols-4 gap-3'>
                                <p className='mb-1'>Service</p>
                                <p className='mb-1 text-[#5D6679] text-end'>Qty.</p>
                                <p className='mb-1 text-[#5D6679] text-end'>Price</p>
                                <p className='mb-1 text-[#5D6679] text-end'>Total</p>
                            </div>
                            {findRoomReservation?.paymentDetails?.products && findRoomReservation?.paymentDetails?.products?.length > 0 &&
                                findRoomReservation?.paymentDetails?.products?.map((product: any, index: number) => {
                                    return (
                                        <div className='grid grid-cols-4 gap-3'>
                                            <p className='mb-1  text-[#5D6679]'>{product?.productName} for {nights || 1} {nights && nights <= 1 ? 'Night' : 'Nights'}</p>
                                            <p className='mb-1 text-[#5D6679] text-end'>{product?.qty}</p>
                                            <p className='mb-1 text-[#5D6679] text-end'>{Number(product?.price || 0)?.toFixed(2)}</p>
                                            <p className='mb-1 text-[#5D6679] text-end'>{Number(product?.totalPerProduct || 0)?.toFixed(2)}</p>
                                        </div>
                                    )
                                })
                            }
                            {(paymentDataInfo?.data && paymentDataInfo?.data?.length > 0) &&
                                paymentDataInfo?.data?.filter((item: any) => item?.productType !== 'room_reservation')?.map((products: any, index: number) => {
                                    return (
                                        <>
                                            {(products?.paymentDetails?.products && products?.paymentDetails?.products?.length > 0) &&
                                                products?.paymentDetails?.products?.map((item: any, idx: number) => {
                                                    return (
                                                        <div key={idx} className='grid grid-cols-4 gap-3'>
                                                            <p className='mb-1 text-[#5D6679]'>{item?.productName}</p>
                                                            <p className='mb-1 text-[#5D6679] text-end'>{item?.qty}</p>
                                                            <p className='mb-1 text-[#5D6679] text-end'>{Number(item?.price || 0)?.toFixed(2)}{CURRENCY_SYMBOLS[`${(item?.currency || '')}`]}</p>
                                                            <p className='mb-1 text-[#5D6679] text-end'>{Number(item?.totalPerProduct || 0)?.toFixed(2)}{CURRENCY_SYMBOLS[`${(item?.currency || '')}`]}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </>
                                    )
                                })
                            }
                            <div className='my-8 flex flex-row justify-end '>
                                <div className='rounded-full bg-[#F2F5F9] flex flex-row items-center justify-between px-5 py-3'>
                                    <p className='mr-8 text-[16px]'>Total</p>
                                    <p>{Number(totalPriceEverything || 0)?.toFixed(2)}{CURRENCY_SYMBOLS[`${(data?.paymentDetails?.currency || '')}`]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mt-6 !rounded-xl border-2 border-call-default'>
                        <div className={'border-b border-b-call-default py-3 px-2 bg-[#f8f9fd]'}>
                            <p className='text-[#5D6679] text-[14px]'>Invoices</p>
                        </div>
                        <div className='py-3 px-2 bg-[#ffffff]'>
                            {(paymentDataInfo?.data && paymentDataInfo?.data?.length > 0) && paymentDataInfo?.data?.map((invoice: any, index: number) => {
                                const totalAmount = (invoice?.paymentDetails?.products && invoice?.paymentDetails?.products?.length > 0) && invoice?.paymentDetails?.products?.reduce((accumulator: any, currentValue: any) => accumulator + (currentValue?.totalPerProduct * currentValue?.qty), 0)
                                return (
                                    <div key={index} className='flex flex-row items-center justify-between my-2'>
                                        <div className='flex flex-row items-center'>
                                            <div onClick={() => onClickDownloadInvoice(invoice?.paymentDetails?.invoiceLink)}>
                                                <p className='underline text-[#5D6679] cursor-pointer mr-2'>{invoice?.paymentDetails?.invoiceNumber}</p>
                                            </div>
                                            <p className='text-[#5D6679] mr-2'>- {moment(invoice?.createdAt).format('MMMM Do, YYYY')}</p>
                                            <p className='text-[#5D6679] mr-2'>- {invoice?.productType === 'room_reservation' ? 'Booking' : 'Service'}</p>
                                            <p className='text-[#5D6679]'>- {Number(totalAmount || 0)?.toFixed(2)}{CURRENCY_SYMBOLS[`${(invoice?.paymentDetails?.products?.[0]?.currency || '').toLowerCase()}`]}</p>
                                        </div>
                                        <div className='mr-2'>{item}</div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className='flex flex-row justify-center my-5'>
                    <Button
                        label={'Close Modal'}
                        className='btn-primary-rounded-less min-w-[140px]'
                        onClickButton={onCloseModal}
                    />
                </div>
            </div>
        </Modal >
    )
}
export default ReservationDetailsModal;